export enum AccountingLogos {
  xeroLogo = 'assets/logos/xero.png',
  sageLogo = 'assets/logos/sage50.png',
}
